import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesWorkspaceUsageDetailsPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./pipelines-usage-details'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesWorkspaceUsageDetailsPageLoadable;
